//import Editor from './Editor.vue';
import Upload from './Upload.vue';
import Tabbar from './Tabbar.vue';
import DayBar from './DayBar.vue';
const install = function(Vue) {
	Vue.component(Upload.name, Upload)
	Vue.component(Tabbar.name, Tabbar)
	Vue.component(DayBar.name, DayBar)
}
export default {
	install
}


// WEBPACK FOOTER //
// ./src/components/custom/index.js